import { FIELD_TYPES } from "@hyro-components/fields/utils";

export const FIELDS = {
  assistantName: {
    id: "assistantName",
    headerName: "Agent name",
    enableFilter: true,
    filterType: FIELD_TYPES.TEXT
  },
  assistantId: {
    id: "assistantId",
    headerName: "Agent link",
    enableFilter: true,
    filterType: FIELD_TYPES.TEXT,
    width: 150
  },
  type: {
    id: "type",
    headerName: "Type",
    enableFilter: true,
    filterType: FIELD_TYPES.TEXT
  },
  status: {
    id: "status",
    headerName: "Status",
    enableFilter: true,
    filterType: FIELD_TYPES.TEXT
  },
  pipelineLink: {
    id: "pipelineLink",
    headerName: "Pipeline link",
    enableFilter: true,
    filterType: FIELD_TYPES.TEXT,
    width: 150
  },
  ddLink: {
    id: "ddLink",
    headerName: "DD link",
    enableFilter: true,
    filterType: FIELD_TYPES.TEXT,
    width: 150
  },
  errorMessage: {
    id: "errorMessage",
    headerName: "Error",
    enableFilter: true,
    filterType: FIELD_TYPES.TEXT
  },
  branchName: {
    id: "branchName",
    headerName: "Branch name",
    enableFilter: true,
    filterType: FIELD_TYPES.TEXT
  },
  createdBy: {
    id: "createdBy",
    headerName: "Creator",
    enableFilter: true,
    filterType: FIELD_TYPES.TEXT
  },
  createdAt: {
    id: "createdAt",
    headerName: "Created at",
    enableFilter: true,
    filterType: FIELD_TYPES.TEXT
  }
};

export const FILTERS = Object.values(FIELDS)
  .filter((column) => column.enableFilter)
  .map((column) => ({
    key: column.id,
    label: column.headerName,
    type: column.filterType || FIELD_TYPES.TEXT,
    options: column.options || []
  }));
